import { render, staticRenderFns } from "./UniversityPromo.vue?vue&type=template&id=07e0aa05&"
var script = {}
import style0 from "./UniversityPromo.vue?vue&type=style&index=0&id=07e0aa05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports